<template>
    <div>
        <div class="container">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <router-link :to="{ name: 'PCReDive' }" tag="li" class="breadcrumb-item">
                        <a href="#">首頁</a>
                    </router-link>
                    <router-link :to="{ name: 'Other' }" tag="li" class="breadcrumb-item">
                        <a href="#">其他資訊</a>
                    </router-link>
                    <li class="breadcrumb-item active">
                        {{ $t("Whoami") }}
                    </li>
                </ol>
            </nav>
            <!-- Modal -->
            <div class="modal fade" id="SendLeaderBoard" tabindex="-1" role="dialog" aria-labelledby="SendLeaderBoardLabel" aria-hidden="true">
                <div class="modal-dialog modal-xl" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="SendLeaderBoardLabel">Send Leaderboard</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <div class="d-flex justify-content-between mb-3">
                                <table class="table" v-if="clientWidth > 1000">
                                    <tr>
                                        <th>{{ $t("Avatar") }}</th>
                                        <th>{{ $t("Username") }}</th>
                                        <th>{{ $t("Mode") }}</th>
                                        <th>{{ $t("Round") }}</th>
                                        <th>{{ $t("Score") }}</th>
                                        <th>{{ $t("Time") }}</th>
                                    </tr>
                                    <tr>
                                        <td>
                                            <img @click="expandAvatar" class="img-fluid cursor-pointer" width="50" v-lazy="'/static/images/unit/icon_unit_' + (Number(avatar) + 30) + '.png'" alt="" />
                                        </td>
                                        <td>
                                            <input type="text" autocomplete="off" id="step1" style="width: 50px;" class="form-control d-inline-block" placeholder="" v-on:input="checkLederboardName(1)" v-model="name1" />
                                            <input type="text" autocomplete="off" id="step2" style="width: 50px;" class="form-control d-inline-block" placeholder="" v-on:input="checkLederboardName(2)" v-model="name2" />
                                            <input type="text" autocomplete="off" id="step3" style="width: 50px;" class="form-control d-inline-block" placeholder="" v-on:input="checkLederboardName(3)" v-model="name3" />
                                        </td>
                                        <td>{{ displayMode }}</td>
                                        <td>{{ round }}</td>
                                        <td>{{ score }}</td>
                                        <td>{{ endTime }}</td>
                                    </tr>
                                </table>

                                <div class="row" v-else>
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="">名稱</label>
                                            <div>
                                                <input type="text" autocomplete="off" id="step1" style="width: 50px;" class="form-control d-inline-block" placeholder="" v-on:input="checkLederboardName(1)" v-model="name1" />
                                                <input type="text" autocomplete="off" id="step2" style="width: 50px;" class="form-control d-inline-block" placeholder="" v-on:input="checkLederboardName(2)" v-model="name2" />
                                                <input type="text" autocomplete="off" id="step3" style="width: 50px;" class="form-control d-inline-block" placeholder="" v-on:input="checkLederboardName(3)" v-model="name3" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="">
                                                <th>{{ $t("Round") }}</th>
                                            </label>
                                            <div>{{ round }}</div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="">
                                                <th>{{ $t("Score") }}</th>
                                            </label>
                                            <div>{{ score }}</div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="">
                                                <th>{{ $t("Time") }}</th>
                                            </label>
                                            <div>{{ endTime }}</div>
                                        </div>
                                    </div>
                                    <div class="col-12">
                                        <div class="form-group">
                                            <label for="">
                                                <th>動作</th>
                                            </label>
                                            <div></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <transition name="expand" @enter="enter" @after-enter="afterEnter" @leave="leave">
                                    <div class="col-12" v-if="expandActive">
                                        <div class="d-flex flex-wrap justify-content-center justify-content-lg-start">
                                            <div v-for="item in allStar" class="m-3">
                                                <img class="cursor-pointer" @click="selectAvatar(item.unit_id)" alt="" width="50" v-lazy="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 30) + '.png'" />
                                            </div>
                                        </div>
                                    </div>
                                </transition>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button class="pcbtn primary" @click="sendLeaderboard">
                                {{ $t("Send") }}
                            </button>
                            <button type="button" class="pcbtn" data-dismiss="modal">{{ $t("Close") }}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="item-box">
                <h2 class="item-title">{{ $t("Whoami") }}</h2>
                <!-- <button data-toggle="modal" data-target="#SendLeaderBoard" class="pcbtn primary">
                    send
                </button> -->
                <div class="playground-wrap" :class="getMode">
                    <div class="playground-box">
                        <div class="d-flex justify-content-between my-3">
                            <div class="select-mode">
                                <button class="pcbtn m-2" :class="mode == 1 ? 'active' : ''" @click="changeMode(1)">
                                    Normal
                                </button>
                                <button class="pcbtn m-2" :class="mode == 2 ? 'active' : ''" @click="changeMode(2)">
                                    Hard
                                </button>
                            </div>
                            <div class="text-right">
                                <button class="pcbtn m-2" :class="maxRound == 10 ? 'active' : ''" @click="changeRound(10)">10 {{ $t("Round") }}</button>
                                <button class="pcbtn m-2" :class="maxRound == 20 ? 'active' : ''" @click="changeRound(20)">20 {{ $t("Round") }}</button>
                            </div>
                        </div>
                        <div class="function-bar my-3 d-flex justify-content-between">
                            <input type="text" class="form-control search-btn" :placeholder="$t('enter_full_unitname')" v-model="answerName" aria-label="Search for..." v-on:keyup.enter="submitEvent" />
                            <button class="pcbtn primary" @click="submitEvent" v-if="round != maxRound">
                                {{ $t("Submit") }}
                            </button>
                            <button class="pcbtn danger" @click="resetEvent" v-else>
                                {{ $t("Reset") }}
                            </button>
                        </div>
                        <div class="d-flex justify-content-between mb-3">
                            <div class="btn btn-outline">{{ $t("Round") }}: {{ round }}/ {{ maxRound }}</div>
                            <div class="btn btn-outline">{{ $t("Score") }}: {{ score }}</div>
                            <div class="btn btn-outline">
                                <span class="time"> {{ $t("Time") }}: {{ time }}</span>
                            </div>
                        </div>
                        <div style="min-height: 50px">
                            <h3 class="item-sub-title answer text-center animate__bounceIn" v-show="showAnswer">
                                {{ $t("AnswerIs") }} <span class=""> {{ getI18nName(questItem, "kana") }} </span>
                            </h3>
                        </div>
                    </div>
                    <div class="playground-box " v-if="mode == 2">
                        <div class="">
                            <div class="quest-box-big mx-auto" :style="questImgStyle">
                                <div class="yes-no-box animate__bounceIn" v-if="showTrue">
                                    <img
                                        src="data:image/png;base64,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"
                                    />
                                </div>
                                <div class="yes-no-box animate__bounceIn" v-if="showFalse">
                                    <img
                                        src="data:image/png;base64,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"
                                    />
                                </div>
                                <img v-if="status == 2" class="d-block mx-auto img-fluid" :src="'/static/images/unit_big/unit_big_' + (Number(questItem.unit_id) + this.imgPlus) + '.jpg'" />
                            </div>
                        </div>
                    </div>
                    <div class="playground-box" v-if="mode == 1">
                        <div class="playground1">
                            <div class="yes-no-box animate__bounceIn" v-if="showTrue">
                                <img
                                    src="data:image/png;base64,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"
                                />
                            </div>
                            <div class="yes-no-box animate__bounceIn" v-if="showFalse">
                                <img
                                    src="data:image/png;base64,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"
                                />
                            </div>
                            <div ref="quest-box" class="question-box" :class="currentStatus()" :style="'background-image: url(/static/images/unit_small/' + questItem.unit_id + '.png);'"></div>
                        </div>
                    </div>
                </div>
                <div class="row my-3">
                    <div class="col-12">
                        <p>{{ $t("GuessCap") }}</p>
                        <p>{{ $t("GuessCap1") }}</p>
                        <p>{{ $t("GuessCap2") }}</p>
                        <p>
                            example for 璃乃(奇幻) /リノ（ワンダー）/ Rino (Wonder): <br />
                            (O): 璃乃(奇幻) / 璃乃（奇幻） / 璃乃奇幻 / 璃乃 奇幻 <br />
                            (O): リノ（ワンダー） /リノワンダー /リノ ワンダー <br />
                            (O): RinoWonder / rino wonder / rino(wonder) / Rino (Wonder)<br />
                            (X): 璃奈(奇幻) / 璃奈幻想 / wonder rino / リノ 奇幻 <br />
                        </p>
                    </div>
                </div>

                <div class="my-3">
                    <ins class="adsbygoogle my-3" style="display:block" data-ad-client="ca-pub-8839550417970110" data-ad-slot="5517770705" data-ad-format="auto" data-full-width-responsive="true"></ins>
                </div>

                <h2 class="item-title">{{ $t("Leaderboard") }}</h2>
                <div class="text-mute">update 5 min</div>
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">{{ $t("Avatar") }}</th>
                            <th scope="col">{{ $t("Name") }}</th>
                            <th scope="col">{{ $t("Round") }}</th>
                            <th scope="col">{{ $t("Score") }}</th>
                            <th scope="col">{{ $t("Time") }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, index) in displayLeaderboard" :key="item.id">
                            <th>{{ index + 1 }}</th>
                            <th scope="row">
                                <img class="img-fluid" width="50" v-lazy="'/static/images/unit/icon_unit_' + (Number(item.avatar) + 30) + '.png'" alt="" />
                            </th>
                            <td>{{ item.player_name }}</td>
                            <td>{{ item.max_round }}</td>
                            <td>{{ item.score }}</td>
                            <td>{{ item.finish_time }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";
import moment from "moment";
export default {
    name: "Whoami",
    props: ["clientWidth"],
    data() {
        return {
            allStar: [],
            questItem: {},
            answerName: "",
            showAnswer: false,
            status: 1,
            round: 0,
            score: 0,
            time: "00:00:00.000",
            endTime: "00:00:00.000",
            timeBegan: null,
            timeStopped: null,
            stoppedDuration: 0,
            started: null,
            running: false,
            historicalList: [],
            showTrue: false,
            showFalse: false,
            mode: 1,
            maxRound: 10,
            perScore: 5,
            questImgStyle: "",
            imgPlus: 30,
            name1: "",
            name2: "",
            name3: "",
            avatar: "107501",
            expandActive: false,
            leaderboardN: [],
            leaderboardH: [],
        };
    },
    metaInfo: {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: "我是誰",
        // all titles will be injected into this template
        titleTemplate: "%s | 蘭德索爾圖書館 公主連結 Wiki",
        meta: [
            {
                name: "description",
                content: "本站《蘭德索爾圖書館》為手機遊戲《超異域公主連結☆Re:Dive》裝備/地圖/人物的資訊分享與轉蛋模擬器。資料內容以臺版《超異域公主連結☆Re:Dive》為主。",
            },
        ],
    },
    methods: {
        expandAvatar() {
            this.expandActive = true;
        },
        selectAvatar(unit_id) {
            this.avatar = unit_id;
            this.expandActive = false;
        },
        currentStatus: function() {
            if (this.status == 1) {
                return "blur";
            } else if (this.status == 2) {
                return "trans200";
            } else {
                return "blur";
            }
        },
        checkAnswerName: function() {
            let answer = [
                this.questItem["kana"].replace(/[（）()&＆]|\s/g, "").toLowerCase(),
                this.questItem["jp_kana"].replace(/[（）()&＆]|\s/g, "").toLowerCase(),
                this.questItem["en_kana"].replace(/[（）()&＆]|\s/g, "").toLowerCase(),
                this.questItem["tw_kana"].replace(/[（）()&＆]|\s/g, "").toLowerCase(),
                this.questItem["cn_kana"].replace(/[（）()&＆]|\s/g, "").toLowerCase(),
            ];
            let inputAnswer = this.answerName;
            inputAnswer = inputAnswer.replace(/[（）()]|\s/g, "").toLowerCase();
            $(".quest-box-big").addClass("show");
            if (_.includes(answer, inputAnswer)) {
                this.showTrue = true;
                this.score += this.perScore;
            } else {
                this.showFalse = true;
            }
            if (this.round == this.maxRound) {
                this.endTime = this.time;
                $("#SendLeaderBoard").modal();
                this.stop();
            }
        },
        resetEvent: function() {
            this.round = 0;
            this.score = 0;
            this.endTime = "";
            this.historicalList = [];
            this.resetTimer();
            this.getQuiz();
            this.getQuizH();
        },
        getQuiz: function() {
            this.showAnswer = false;
            this.answerName = "";
            this.showTrue = false;
            this.showFalse = false;
            this.status = 1;
            const count = this.allStar.length;
            let random = Number(_.random(count)) - 1;
            if (random < 0) {
                random = 0;
            }
            if (_.includes(this.historicalList, random)) {
                this.getQuiz();
            }
            this.historicalList.push(random);
            this.questItem = this.allStar[random];
        },
        getQuizH: function() {
            this.imgPlus = 30;
            $(".quest-box-big").removeClass("show");
            function getRandomIntInclusive(min, max) {
                min = Math.ceil(min);
                max = Math.floor(max);
                return Math.floor(Math.random() * (max - min + 1) + min); // The maximum is inclusive and the minimum is inclusive
            }
            if (this.questItem?.star6) {
                if (getRandomIntInclusive(1, 2) == 2) {
                    this.imgPlus = 60;
                }
            }
            let positionX = getRandomIntInclusive(1, 100) + "%";
            let positionY = getRandomIntInclusive(1, 100) + "%";
            this.questImgStyle = {
                "background-size": "cover",
                background: "url(/static/images/unit_big/unit_big_" + (Number(this.questItem.unit_id) + this.imgPlus) + ".jpg)",
                "background-position-x": positionX,
                "background-position-y": positionY,
            };
        },
        submitEvent: function() {
            if (this.status != 1 || this.round == this.maxRound) {
                return;
            }
            if (this.mode == 1) {
                let questBoxClassName = this.$refs["quest-box"].classList.value;
                let questBoxStyle = this.$refs["quest-box"].style.cssText;
                let questBoxBlur = $(".blur").css("filter");
                if (questBoxClassName.indexOf("blur") < 0 || questBoxStyle.indexOf("brightness") > 0 || questBoxBlur != "brightness(0) blur(2px)") {
                    console.log("Cheat!");
                    $("body").css("background", "url('/static/images/Mappu.gif') repeat");
                    var audio = new Audio("/static/images/kururinpo.mp3");
                    audio.loop = true;
                    audio.play();
                    this.score -= 100;
                }
            }

            if (this.answerName == "") {
                return;
            }
            if (this.round == 0) {
                this.startTimer();
            }

            this.round += 1;
            this.showAnswer = true;
            this.status = 2;
            this.checkAnswerName();
            setTimeout(() => {
                switch (this.mode) {
                    case 1:
                        this.getQuiz();
                        break;
                    case 2:
                        this.getQuiz();
                        this.getQuizH();
                        break;
                }
                // this.getQuiz();
            }, 3000);
        },
        changeMode: function(mode) {
            this.mode = mode;
            switch (mode) {
                case 1:
                    this.resetEvent();
                    break;
                case 2:
                    this.resetEvent();
                    break;
            }
        },
        changeRound: function(round) {
            this.resetEvent();
            this.maxRound = round;
            switch (round) {
                case 10:
                    this.perScore = 10;
                    break;
                case 20:
                    this.perScore = 5;
                    break;
            }
        },
        getI18nName: function(item, name) {
            switch (this.locale) {
                case "en":
                    return item["en_" + name];
                    break;
                case "jp":
                    return item["jp_" + name];
                    break;
                case "tw":
                    return item["tw_" + name];
                    break;
                default:
                    return item[name];
                    break;
            }
        },
        watchStart: function() {
            clearInterval(Interval);
            Interval = setInterval(startTimer, 10);
        },
        clockRunning: function() {
            function zeroPrefix(num, digit) {
                var zero = "";
                for (var i = 0; i < digit; i++) {
                    zero += "0";
                }
                return (zero + num).slice(-digit);
            }
            var currentTime = new Date(),
                timeElapsed = new Date(currentTime - this.timeBegan - this.stoppedDuration),
                hour = timeElapsed.getUTCHours(),
                min = timeElapsed.getUTCMinutes(),
                sec = timeElapsed.getUTCSeconds(),
                ms = timeElapsed.getUTCMilliseconds();

            this.time = zeroPrefix(hour, 2) + ":" + zeroPrefix(min, 2) + ":" + zeroPrefix(sec, 2) + "." + zeroPrefix(ms, 3);
        },
        resetTimer: function() {
            this.running = false;
            clearInterval(this.started);
            this.stoppedDuration = 0;
            this.timeBegan = null;
            this.timeStopped = null;
            this.time = "00:00:00.000";
        },
        stop: function() {
            this.running = false;
            this.timeStopped = new Date();
            clearInterval(this.started);
        },
        startTimer: function() {
            if (this.running) return;

            if (this.timeBegan === null) {
                this.resetTimer();
                this.timeBegan = new Date();
            }

            if (this.timeStopped !== null) {
                this.stoppedDuration += new Date() - this.timeStopped;
            }

            this.started = setInterval(this.clockRunning, 10);
            this.running = true;
        },
        checkLederboardName: function(step) {
            function nameVerify(name) {
                if (name.length > 1) {
                    name = name.substring(1, 2);
                }
                let res = /^[a-zA-Z]+$/.test("sfjd");
                if (res) {
                    name = name.toUpperCase();
                } else {
                    name = "A";
                }

                return name;
            }
            switch (step) {
                case 1:
                    this.name1 = nameVerify(this.name1);
                    $("#step2").focus();
                    $("#step2").select();
                    break;
                case 2:
                    this.name2 = nameVerify(this.name2);
                    $("#step3").focus();
                    $("#step3").select();
                    break;
                case 3:
                    this.name3 = nameVerify(this.name3);
                    $("#step1").focus();
                    $("#step1").select();
                    break;
            }
        },
        enter(element) {
            const width = getComputedStyle(element).width;

            element.style.width = width;
            element.style.position = "absolute";
            element.style.visibility = "hidden";
            element.style.height = "auto";

            const height = getComputedStyle(element).height;

            element.style.width = null;
            element.style.position = null;
            element.style.visibility = null;
            element.style.height = 0;

            // Force repaint to make sure the
            // animation is triggered correctly.
            getComputedStyle(element).height;

            // Trigger the animation.
            // We use `requestAnimationFrame` because we need
            // to make sure the browser has finished
            // painting after setting the `height`
            // to `0` in the line above.
            requestAnimationFrame(() => {
                element.style.height = height;
            });
        },
        afterEnter(element) {
            element.style.height = "auto";
        },
        leave(element) {
            const height = getComputedStyle(element).height;

            element.style.height = height;

            // Force repaint to make sure the
            // animation is triggered correctly.
            getComputedStyle(element).height;

            requestAnimationFrame(() => {
                element.style.height = 0;
            });
        },
        sendLeaderboard() {
            var self = this;
            if (this.round != this.maxRound) {
                //$("#SendLeaderBoard").modal("hide");
                //return;
            }
            var url = "/static/php/leaderboardAdd.php";
            let converTime = moment(this.endTime, "HH:mm:ss: SSS").diff(moment().startOf("day"), "milliseconds");
            let player_name = self.name1 + self.name2 + self.name3;
            if (!player_name) {
                player_name = "AAA";
            }
            var data = {
                player_name: player_name,
                avatar: this.avatar,
                mode: this.mode,
                max_round: this.round,
                score: this.score,
                finish_time: this.endTime,
                convert_sec: converTime,
            };
            $.ajax({
                type: "POST",
                url: url,
                data: data,
                success: function(data) {
                    var res = data.toString().trim();
                    if (res == "200") {
                        console.log("送出成功");
                    }
                },
                error: function(res) {
                    console.log(res);
                },
            });
            $("#SendLeaderBoard").modal("hide");
        },
        getLeaderboard() {
            var self = this;
            var url = "/static/php/leaderboardGet.php";
            // axios.get("/static/data/leaderboard.json").then(function(response) {
            //     console.log(response);
            //     self.leaderboardN = response.data.list[0];
            //     self.leaderboardH = response.data.list[1];
            // });
            $.ajax({
                type: "POST",
                url: url,
                success: function(response) {
                    let rsp = response;
                    if (typeof response == "string") {
                        rsp = JSON.parse(response);
                    }
                    self.leaderboardN = rsp.list[0];
                    self.leaderboardH = rsp.list[1];
                },
                error: function(res) {
                    console.log(res);
                },
            });
        },
    },
    created: function() {
        var self = this;
        var units = self.$store.getters.getUnitData;
        var actualUnits = this.$store.getters.getCharaIdentity;
        var starList = new Array();
        _.forEach(units, function(value) {
            _.forEach(actualUnits, function(o) {
                if (o.unit_id == "170201") {
                    return;
                }
                if (o.unit_id == _.toInteger(value.unit_id)) {
                    var has6star = _.find(self.$store.getters.getUnitRarity, { unit_id: value.unit_id, rarity: "6" });
                    if (has6star) {
                        o["star6"] = true;
                    } else {
                        o["star6"] = false;
                    }
                    o["en_kana"] = value.en_unit_name;
                    o["jp_kana"] = value.jp_unit_name;
                    o["tw_kana"] = value.tw_unit_name;
                    o["cn_kana"] = value.cn_unit_name;
                    o["rarity"] = value.rarity;
                    o["kana"] = value.unit_name;
                    starList.push(o);
                }
            });
        });
        self.allStar = starList;
    },
    computed: {
        locale() {
            return this.$i18n.locale;
        },
        getMode() {
            switch (this.mode) {
                case 1:
                    return "mode1";
                case 2:
                    return "mode2";
            }
        },
        displayMode() {
            switch (this.mode) {
                case 1:
                    return "Normal";
                case 2:
                    return "Hard";
            }
        },
        displayLeaderboard() {
            var self = this;
            switch (this.mode) {
                case 1:
                    return _.filter(this.leaderboardN, (o) => {
                        return o.max_round == self.maxRound;
                    });
                case 2:
                    return _.filter(this.leaderboardH, (o) => {
                        return o.max_round == self.maxRound;
                    });
            }
        },
    },
    mounted: function() {
        (adsbygoogle = window.adsbygoogle || []).push({});
        this.getQuiz();
        this.getQuizH();
        this.getLeaderboard();
    },
};
</script>
<style scoped>
@import "https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css";
</style>
